import { useState } from 'react'
import { cn } from '../lib/utils'

interface ThoughtBlockProps {
  thinking: string
}

export function ThoughtBlock({ thinking }: ThoughtBlockProps) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="mb-3 rounded-lg border border-[hsl(var(--accent)/0.2)] bg-[hsl(var(--accent-soft))] overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex w-full items-center gap-2 px-3 py-2 text-small text-[hsl(var(--accent))] hover:bg-[hsl(var(--accent)/0.1)] transition-colors"
      >
        <svg
          className={cn('h-3.5 w-3.5 transition-transform duration-200', expanded && 'rotate-90')}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        <span className="font-medium">View reasoning</span>
        <span className="ml-auto text-caption opacity-60">
          {expanded ? 'collapse' : 'expand'}
        </span>
      </button>
      {expanded && (
        <div className="border-t border-[hsl(var(--accent)/0.1)] px-3 py-2">
          <div className="prose prose-invert prose-sm max-w-none">
            <p className="whitespace-pre-wrap font-mono text-caption leading-relaxed text-[hsl(var(--accent)/0.8)]">
              {thinking}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
